import {Card, Col, OverlayTrigger, Row, Spinner, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import VmaTable from "../../Components/VmaTable/VmaTable";
import CuWaterSystemsTable from "../../Components/CuWaterSystemsTable/CuWaterSystemsTable";
import {useEffect, useLayoutEffect, useRef, useState} from "react";
import MetersTable from "../../Components/MetersTable/MetersTable";
import ValvesTable from "../../Components/ValvesTable/ValvesTable";
import {BiTachometer} from "react-icons/bi";
import AddIcon from '@mui/icons-material/Add';
import {GrConnect} from "react-icons/gr";
import {TbCopy} from "react-icons/tb";
import AddVmaModal from "./AddVmaModal";
import EditVmaModal from "./EditVmaModal";
import DeleteVmaModal from "./DeleteVmaModal";
import AddWaterSystemModal from "./AddWaterSystemModal";
import {WINT_SITES_ROUTE, WINT_WATER_SYSTEMS_ROUTE} from "../../Constants/constants";
import React from "react";
import {UPDATE_VMA_DROPDOWN_OPTIONS, UPDATE_VMA_LIST} from "../../Store/ActionTypes/General/actionTypes";
import {
    CONNECTED,
    DISABLED,
    DISCONNECTED,
    DOWNLOADING,
    ERROR,
    NOT_SUPPORTED,
    OK,
    PAIRED,
    PAIRING,
    SWITCHING,
    TRAFFIC_ISSUE_SUSPECT,
    UNKNOWN,
    UNKNOWN_ENUM,
    UNPAIRED,
    UNPAIRING,
    WAIT_GET_GUID_RES,
    WAIT_RESET_ADDR_RES,
    WAIT_SET_ADDR_RES,
    WAIT_SET_GREEN_LED_RES
} from "./Types";
import ErrorModal from "./ErrorModal";
import {RiFullscreenFill, RiWaterFlashFill} from "react-icons/ri";
import valveIcon from "../../Images/valve-icon.svg"
import CustomIcon from "../../Components/CustomIcon/CustomIcon";
import greenCircle from "../../Images/green-circle.png";
import redCircle from "../../Images/red-circle.png";
import purpleCircle from "../../Images/purple-circle.png";
import greyCircle from "../../Images/grey-circle.png";
import DeleteWaterSystemModal from "./DeleteWaterSystemModal";
import {RiDeleteBin6Line} from "react-icons/ri";
import DeleteWaterSystemConfirmationModal from "./DeleteWaterSystemConfirmationModal";
import {IconButton} from "@mui/material";
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

export default function ControlUnitConfigPage({
                                                  vmaData,
                                                  copyTextToClipboard,
                                                  controlUnitId,
                                                  controlUnitService,
                                                  dispatch,
                                                  setIsUpdateDetailsRequestInProgress,
                                                  setIsPollingActive,
                                                  updateCuDetailsState,
                                                  setVmaData,
                                                  errorMessage,
                                                  setShowErrorModal,
                                                  showErrorModal,
                                                  isApplyingActive,
                                                  isUpdateDetailsRequestInProgress,
                                                  isNoWaterSystems,
                                                  waterSystemData,
                                                  metersData,
                                                  valvesData,
                                                  connectionState,
                                                  renderButtons,
                                                  shouldReload,
                                                  controlUnitDetails,
                                                  setControlUnitDetails
                                              }) {
    const [showAddVmaModal, setShowAddVmaModal] = useState(false);
    const [showAddWaterSystemModal, setShowAddWaterSystemModal] = useState(false);
    const [showEditVmaModal, setShowEditVmaModal] = useState(false);
    const [showDeleteVmaModal, setShowDeleteVmaModal] = useState(false);
    const [showDeleteWaterSystemModal, setShowDeleteWaterSystemModal] = useState(false);
    const [showDeleteWaterSystemConfirmationModal, setShowDeleteWaterSystemConfirmationModal] = useState(false);
    const [isWaterSystemdDeletedSuccessfully, setIsWaterSystemDeletedSuccessfully] = useState(false);
    const [isVmaActionDropDownMenuOpen, setIsVmaActionDropDownMenuOpen] = useState(false);
    const [selectedVmaRow, setSelectedVmaRow] = useState(null);
    const [pairingVmaIdList, setPairingVmaIdList] = useState([]);
    const [pairingVmaUuid, setPairingVmaUuid] = useState(null);
    const [downloadingFirmwareVmaId, setDownloadingFirmwareVmaId] = useState(null);
    const [switchingFirmwareVmaId, setSwitchingFirmwareVmaId] = useState(null);
    const [isPairActive, setIsPairActive] = useState(false);
    const [isDownloadActive, setIsDownloadActive] = useState(false);
    const [isSwitchActive, setIsSwitchActive] = useState(false);
    const [isVmaPollingInProgress, setIsVmaPollingInProgress] = useState(false);
    const [modelDropdownOptions, setModelDropdownOptions] = useState([]);
    const [selectedWaterSystemId, setSelectedWaterSystemId] = useState(null);
    const [focusedTable, setFocusedTable] = useState(null);
    const POLLING_TIME_INTERVAL = 5000;

    const renderFullScreenButton = (tableName) => {
        return <IconButton
            color={'primary'}
            onClick={() => toggleFocus(tableName)}
        >
            {focusedTable === tableName ? <FullscreenExitIcon sx={{color:'#66B2FF'}} className='mr-1'/> : <FullscreenIcon sx={{color:'#66B2FF'}} />}
        </IconButton>
    }

    const toggleFocus = (tableName) => {
        setFocusedTable((prev) => (prev === tableName ? null : tableName));
    };

    const shouldRenderTable = (tableName) => !focusedTable || focusedTable === tableName

    const waterSystemNameFormatter = (cell, row) => {
        let href = `${process.env.REACT_APP_SUPPORT_DASHBOARD_WINT_AI_CONTROL_URL}/${WINT_SITES_ROUTE}/${row?.siteId}/${WINT_WATER_SYSTEMS_ROUTE}/${row?.id}`;
        return <a target="_blank" rel="noreferrer" href={href}>{cell}</a>
    }

    const Name = ({cell}) => {
        const [showToolTip, setShowToolTip] = useState(false);
        const ref = useRef(null);

        useLayoutEffect(() => {
            if (ref.current.clientWidth < ref.current.scrollWidth) {
                setShowToolTip(true);
            }
        }, [ref]);

        return (<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div className={'d-inline-block'}>
            </div>
            {showToolTip ? <OverlayTrigger placement="right" overlay={<Tooltip> {cell}</Tooltip>}>
                    <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>
                        {cell}
                    </div>
                </OverlayTrigger> :
                <div ref={ref} style={{overflow: 'hidden', textOverflow: 'ellipsis'}} className={'d-inline-block'}>
                    {cell}
                </div>}

            <div className={'d-inline-block'}>
                <Button className='p-0 m-0' variant={'link'} style={{color: 'black'}}>
                    <TbCopy onClick={() => copyTextToClipboard(cell)} size={25}/>
                </Button>
            </div>
        </div>)
    }

    const nameFormatter = (cell) => {
        return (<Name cell={cell?.name}/>);
    }

    const connectivityStatusFormatter = (cell) => {
        let statusIcon;
        let status;
        switch (cell) {
            case CONNECTED:
                statusIcon = <CustomIcon
                    className={'ml-2 mb-1'}
                    width={20}
                    height={20}
                    src={greenCircle}
                    alt={"greenCircle"}
                />
                status = CONNECTED.charAt(0) + CONNECTED.toLowerCase().substring(1);
                break;
            case DISCONNECTED:
                statusIcon = <CustomIcon
                    className={'ml-2 mb-1'}
                    width={20}
                    height={20}
                    src={redCircle}
                    alt={"redCircle"}
                />
                status = DISCONNECTED.charAt(0) + DISCONNECTED.toLowerCase().substring(1);
                break;
            case DISABLED:
                statusIcon = <CustomIcon
                    className={'ml-2 mb-1'}
                    width={18}
                    height={18}
                    src={purpleCircle}
                    alt={"purpleCircle"}
                />
                status = DISABLED.charAt(0) + DISABLED.toLowerCase().substring(1);
                break;
            case NOT_SUPPORTED:
            case UNKNOWN:
            default:
                statusIcon = <CustomIcon
                    className={'ml-2 mb-1'}
                    width={20}
                    height={20}
                    src={greyCircle}
                    alt={"greyCircle"}
                />
                status = UNKNOWN.charAt(0) + UNKNOWN.toLowerCase().substring(1);
        }
        return <OverlayTrigger
            placement='left'
            overlay={<Tooltip>{status}</Tooltip>}>
            <span tabindex="0">{statusIcon}</span>
        </OverlayTrigger>
    }

    const waterSystemDeleteFormatter = (cell, row) => {
        return <div>
            <Button className='p-0' onClick={() => {
                setSelectedWaterSystemId(row.id);
                setShowDeleteWaterSystemModal(true);
            }} variant='link'><RiDeleteBin6Line color='red' size={20}/></Button>
        </div>
    }

    const createVmaDropdownList = () => {
        let list = []
        if (vmaData.length > 0) {
            list.push({value: '', label: ''})
            vmaData.forEach(vma => {
                list.push({value: vma.uuid, label: vma.name})
            })
        }
        return list;
    }

    const createVmaList = () => {
        let list = []
        vmaData.forEach(vma => {
            list.push({
                uuid: vma.uuid, name: vma.name, meters: vma.meterUuids, valves: vma.valveUuids
            })
        })
        return list;
    }

    const getCurrentDownloadingFirmwareVmaId = () => {
        vmaData.forEach((vma) => {
            if (vma.firmwareDownloadState === DOWNLOADING) {
                setDownloadingFirmwareVmaId(vma.id);
                setIsDownloadActive(true);
                setIsVmaPollingInProgress(true);
            }
        })
    }

    const getCurrentSwitchingFirmwareVmaId = () => {
        vmaData.forEach((vma) => {
            if (vma.firmwareSwitchState === SWITCHING) {
                setSwitchingFirmwareVmaId(vma.id);
                setIsSwitchActive(true);
                setIsVmaPollingInProgress(true);
            }
        })
    }

    const getCurrentPairingVmaId = () => {
        vmaData.forEach((vma) => {
            if (vma.pairingState === PAIRING || vma.pairingState === UNPAIRING) {
                setPairingVmaUuid(vma.uuid);
                setIsPairActive(true);
                setIsVmaPollingInProgress(true);
            }
        })
    }

    const updateVmaDropdownArr = (dataArr) => {
        dispatch({
            type: UPDATE_VMA_DROPDOWN_OPTIONS, payload: dataArr
        });
    }

    const updateVmaListArr = (dataArr) => {
        dispatch({
            type: UPDATE_VMA_LIST, payload: dataArr
        });
    }

    const addNewVma = async (name, model) => {
        setIsUpdateDetailsRequestInProgress(true);
        const response = await controlUnitService.addVma(controlUnitId, name, model);
        if (!response) {
            setIsUpdateDetailsRequestInProgress(false);
            console.error(`Data from add vma is empty`);
            return;
        }
        setIsUpdateDetailsRequestInProgress(false);
        updateCuDetailsState(response);
        setShowAddVmaModal(false);

    }

    const editVma = async (payload, vmaUuid) => {
        setIsUpdateDetailsRequestInProgress(true);
        const response = await controlUnitService.editVma(controlUnitId, vmaUuid, payload);
        if (!response) {
            setIsUpdateDetailsRequestInProgress(false);
            console.error(`Data from edit vma is empty`);
            return;
        }
        setIsUpdateDetailsRequestInProgress(false);
        updateCuDetailsState(response);
        setShowEditVmaModal(false);
    }

    const deleteVma = async (vmaUuid) => {
        setIsUpdateDetailsRequestInProgress(true);
        const response = await controlUnitService.deleteVma(controlUnitId, vmaUuid);
        if (!response) {
            setIsUpdateDetailsRequestInProgress(false);
            console.error(`Data from delete vma is empty`);
            return;
        }
        setIsUpdateDetailsRequestInProgress(false);
        updateCuDetailsState(response);
        setShowDeleteVmaModal(false);
    }

    const deleteWaterSystem = async (controlUnitId, waterSystemId) => {
        try {
            await controlUnitService.deleteWaterSystem(controlUnitId, waterSystemId);
            setIsWaterSystemDeletedSuccessfully(true);
        } catch (e) {
            setIsWaterSystemDeletedSuccessfully(false);
        }
        setShowDeleteWaterSystemModal(false);
    }

    const getVmaModels = async () => {
        const response = await controlUnitService.getModbusModels();
        if (!response) {
            console.error(`Data from get Vma Models is empty`);
            return;
        }
        const modelList = response.data.map((str) => {
            return {value: str, label: str}
        })
        setModelDropdownOptions(modelList);
    }

    useEffect(() => {
        getVmaModels();
    }, [])

    useEffect(() => {
        if (vmaData) {
            updateVmaDropdownArr(createVmaDropdownList());
            updateVmaListArr(createVmaList());
            getCurrentDownloadingFirmwareVmaId();
            getCurrentSwitchingFirmwareVmaId();
            getCurrentPairingVmaId();
        }
    }, [vmaData])

    useEffect(() => {
        if (isPairActive) {
            setIsPairActive(false);
            let intervalNum = setInterval(async () => {
                const response = await controlUnitService.getVmaStatus(controlUnitId, pairingVmaUuid);
                if (!response) {
                    console.error(`Data from vma pairing status is empty`);
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    return;
                }
                if ([PAIRED, UNPAIRED, ERROR, UNKNOWN_ENUM, DISCONNECTED, WAIT_SET_ADDR_RES, WAIT_RESET_ADDR_RES, WAIT_GET_GUID_RES, WAIT_SET_GREEN_LED_RES, TRAFFIC_ISSUE_SUSPECT].includes(response.data)) {
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    let newVmaData = vmaData.map(vma => pairingVmaUuid !== vma.uuid ? vma : {
                        ...vma,
                        pairingState: response.data
                    });
                    setVmaData(newVmaData);
                }
            }, POLLING_TIME_INTERVAL)
        }
    }, [isPairActive])

    useEffect(() => {
        if (isDownloadActive) {
            setIsDownloadActive(false);
            let intervalNum = setInterval(async () => {
                const response = await controlUnitService.getDownloadStatus(controlUnitId, downloadingFirmwareVmaId);
                if (!response) {
                    console.error(`Data from vma firmware download status is empty`);
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    return;
                }
                if ([OK, ERROR].includes(response.data)) {
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    let newVmaData = vmaData.map(vma => {
                        if (downloadingFirmwareVmaId === vma.id) {
                            if (response.data === ERROR) {
                                return {...vma, firmwareDownloadState: OK};
                            } else {
                                return {...vma, firmwareDownloadState: response.data};
                            }
                        } else {
                            return vma;
                        }
                    })
                    setVmaData(newVmaData);
                }
            }, POLLING_TIME_INTERVAL)
        }
    }, [isDownloadActive])

    useEffect(() => {
        if (isSwitchActive) {
            setIsSwitchActive(false);
            let intervalNum = setInterval(async () => {
                const response = await controlUnitService.getSwitchStatus(controlUnitId, switchingFirmwareVmaId);
                if (!response) {
                    console.error(`Data from vma firmware switch status is empty`);
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    return;
                }
                if ([OK, ERROR].includes(response.data)) {
                    setIsVmaPollingInProgress(false);
                    clearInterval(intervalNum);
                    let newVmaData = vmaData.map(vma => {
                        if (switchingFirmwareVmaId === vma.id) {
                            if (response.data === ERROR) {
                                return {...vma, firmwareSwitchState: OK};
                            } else {
                                return {...vma, firmwareSwitchState: response.data};
                            }
                        } else {
                            return vma;
                        }
                    })
                    setVmaData(newVmaData);
                }
            }, POLLING_TIME_INTERVAL)
        }
    }, [isSwitchActive])

    useEffect(() => {
        [showEditVmaModal, showAddVmaModal, showErrorModal, showDeleteVmaModal, showAddWaterSystemModal, isVmaActionDropDownMenuOpen].includes(true) ? setIsPollingActive(false) : setIsPollingActive(true);
    }, [showEditVmaModal, showAddVmaModal, showErrorModal, showDeleteVmaModal, showAddWaterSystemModal, isVmaActionDropDownMenuOpen])

    return (<>
        <AddVmaModal addNewVma={addNewVma}
                     vmaData={vmaData}
                     setVmaData={setVmaData}
                     setShow={setShowAddVmaModal}
                     show={showAddVmaModal}
                     modelDropdownOptions={modelDropdownOptions}
        />
        <AddWaterSystemModal setShow={setShowAddWaterSystemModal}
                             controlUnitService={controlUnitService}
                             show={showAddWaterSystemModal}
                             controlUnitId={controlUnitId}
        />
        <EditVmaModal isPollingInProgress={isVmaPollingInProgress}
                      controlUnitService={controlUnitService}
                      editVma={editVma}
                      setDownloadingFirmwareVmaId={setDownloadingFirmwareVmaId}
                      downloadingFirmwareVmaId={downloadingFirmwareVmaId}
                      setSwitchingFirmwareVmaId={setSwitchingFirmwareVmaId}
                      switchingFirmwareVmaId={switchingFirmwareVmaId}
                      setPairingVmaUuid={setPairingVmaUuid}
                      setIsPollingInProgress={setIsVmaPollingInProgress}
                      setIsPairClicked={setIsPairActive}
                      setIsDownloadClicked={setIsDownloadActive}
                      setIsSwitchClicked={setIsSwitchActive}
                      setPairingVmaIdList={setPairingVmaIdList}
                      pairingVmaIdList={pairingVmaIdList}
                      vmaData={vmaData}
                      setVmaData={setVmaData}
                      controlUnitId={controlUnitId}
                      selectedVmaRow={selectedVmaRow}
                      setSelectedVmaRow={setSelectedVmaRow}
                      setShow={setShowEditVmaModal}
                      controlUnitDetails={controlUnitDetails}
                      show={showEditVmaModal}
        />
        <DeleteVmaModal setShow={setShowDeleteVmaModal}
                        deleteVma={deleteVma}
                        selectedVmaRow={selectedVmaRow}
                        vmaData={vmaData}
                        setVmaData={setVmaData}
                        show={showDeleteVmaModal}
        />
        <DeleteWaterSystemModal setShow={setShowDeleteWaterSystemModal}
                                deleteWaterSystem={deleteWaterSystem}
                                selectedWaterSystemId={selectedWaterSystemId}
                                controlUnitId={controlUnitId}
                                show={showDeleteWaterSystemModal}
                                setShowDeleteWaterSystemConfirmationModal={setShowDeleteWaterSystemConfirmationModal}
        />
        <DeleteWaterSystemConfirmationModal
            setShow={setShowDeleteWaterSystemConfirmationModal}
            show={showDeleteWaterSystemConfirmationModal}
            isWaterSystemdDeletedSuccessfully={isWaterSystemdDeletedSuccessfully}
        />
        <ErrorModal errorMessage={errorMessage}
                    setShow={setShowErrorModal}
                    show={showErrorModal}
                    shouldReload={shouldReload}
        />
        <Card bsPrefix='tabCard' className={'mr-3 pt-3 ml-3'} >
            <Row className={'mr-1 ml-1'}>
                {shouldRenderTable("vma") && (<Col>
                    <Card>
                        <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div className={'d-inline-block'}>
                                </div>
                                <div className={'d-inline-block'}>
                                    <div className='d-inline'>
                                        VMA
                                    </div>
                                    <div className='d-inline'>
                                        <GrConnect className={'ml-2 mb-1'} size={25}/>
                                    </div>
                                </div>
                                <div className={'d-inline-block'}>
                                    <IconButton color={'primary'} className={'mr-2'}  sx={{border:'none'}} onClick={() => setShowAddVmaModal(true)}>
                                        <AddIcon fontSize='sm' sx={{color:'#66B2FF'}}/>
                                    </IconButton>
                                    {renderFullScreenButton("vma")}
                                </div>
                            </div>
                        </Card.Header>
                        <Card.Body className='pt-2 pb-1'>
                            {Object.keys(controlUnitDetails).length > 0 ?
                                <VmaTable isUpdateDetailsRequestInProgress={isUpdateDetailsRequestInProgress}
                                          setIsPollingActive={setIsPollingActive}
                                          setIsVmaActionDropDownMenuOpen={setIsVmaActionDropDownMenuOpen}
                                          isApplyingActive={isApplyingActive}
                                          copyTextToClipboard={copyTextToClipboard} setSelectedRow={setSelectedVmaRow}
                                          setShowDeleteVmaModal={setShowDeleteVmaModal}
                                          setShowEditVmaModal={setShowEditVmaModal}
                                          nameFormatter={nameFormatter}
                                          data={vmaData}
                                          connectionState={connectionState}
                                          tableHeight={focusedTable === "vma" ? null : 250}
                                /> : <Spinner animation={'border'} variant={'primary'}/>
                            }
                        </Card.Body>
                    </Card>
                </Col>)}
                {shouldRenderTable("waterSystems") && (<Col>
                    <Card>
                        <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div className={'d-inline-block'}>
                                </div>
                                <div className={'d-inline-block'}>
                                    <div className='d-inline'>Water Systems</div>
                                    <div className='d-inline'><RiWaterFlashFill className={'ml-2 mb-1'} size={25}/>
                                    </div>
                                </div>
                                <div className={'d-inline-block'}>
                                    <IconButton color='primary' className={'mr-2'} size='sm' onClick={() => setShowAddWaterSystemModal(true)}>
                                        <AddIcon sx={{color:'#66B2FF'}} />
                                    </IconButton>
                                    {renderFullScreenButton("waterSystems")}

                                </div>

                            </div>
                        </Card.Header>
                        <Card.Body className='pt-3 pb-3'>
                            <CuWaterSystemsTable isNoWaterSystems={isNoWaterSystems}
                                                 isApplyingActive={isApplyingActive}
                                                 isUpdateDetailsRequestInProgress={isUpdateDetailsRequestInProgress}
                                                 waterSystemNameFormatter={waterSystemNameFormatter}
                                                 waterSystemDeleteFormatter={waterSystemDeleteFormatter}
                                                 data={waterSystemData}
                                                 tableHeight={focusedTable === "waterSystems" ? null : 230}
                            />
                        </Card.Body>
                    </Card>
                </Col>)}
            </Row>
            <Row className={'mt-3 mr-1 ml-1'}>
                {shouldRenderTable("meters") && (<Col>
                    <Card>
                        <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <div/>
                                <div>
                                    <div className={'d-inline'}>Meters</div>
                                    <div className={'d-inline'}><BiTachometer className={'ml-2 mb-1'} size={25}/></div>
                                </div>
                                {renderFullScreenButton("meters")}

                            </div>


                        </Card.Header>
                        <Card.Body className='pt-3 pb-3'>
                            {
                                Object.keys(controlUnitDetails).length > 0 ?
                                    <MetersTable connectivityStatusFormatter={connectivityStatusFormatter}
                                                 isApplyingActive={isApplyingActive}
                                                 isUpdateDetailsRequestInProgress={isUpdateDetailsRequestInProgress}
                                                 updateVmaListArr={updateVmaListArr}
                                                 nameFormatter={nameFormatter}
                                                 data={metersData}
                                                 controlUnitDetails={controlUnitDetails}
                                                 setControlUnitDetails={setControlUnitDetails}
                                                 vmaData={vmaData}
                                                 tableHeight={focusedTable === "meters" ? null : 265}


                                    /> : <Spinner animation={'border'} variant={'primary'}/>
                            }
                        </Card.Body>
                    </Card>

                </Col>)}
                {shouldRenderTable("valves") && (<Col>
                    <Card>
                        <Card.Header style={{borderTopLeftRadius: '1.25rem', borderTopRightRadius: '1.25rem'}}>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                                <div/>
                                <div>
                                    <div className={'d-inline'}>Valves</div>
                                    <div className={'d-inline'}>
                                        <CustomIcon
                                            className={'ml-2 mb-1'}
                                            width={25}
                                            height={25}
                                            src={valveIcon}
                                            alt={"valveIcon"}
                                        />
                                    </div>
                                </div>
                                {renderFullScreenButton("valves")}
                            </div>
                        </Card.Header>
                        <Card.Body className='pt-3 pb-3'>
                            {
                                Object.keys(controlUnitDetails).length > 0 ?
                                    <ValvesTable connectivityStatusFormatter={connectivityStatusFormatter}
                                                 isApplyingActive={isApplyingActive}
                                                 isUpdateDetailsRequestInProgress={isUpdateDetailsRequestInProgress}
                                                 updateVmaListArr={updateVmaListArr} nameFormatter={nameFormatter}
                                                 data={valvesData}
                                                 controlUnitDetails={controlUnitDetails}
                                                 setControlUnitDetails={setControlUnitDetails}
                                                 vmaData={vmaData}
                                                 tableHeight={focusedTable === "valves" ? null : 265}/> :
                                    <Spinner animation={'border'} variant={'primary'}/>
                            }
                        </Card.Body>
                    </Card>
                </Col>)}
            </Row>
            {!focusedTable && <Row>
                <Col>
                    {renderButtons()}
                </Col>
            </Row>}
        </Card>
    </>)
}
